import styled from "styled-components";




export const Title = styled.div`
    color: #000;
    font-family: "Saira Semi Condensed", sans-serif;
    font-size: 36px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-bottom: 28px;
    margin-top: -20px;
    text-align: center;
`;

export const CreateRoomContainer= styled.div`
    font-family: "Saira Semi Condensed", sans-serif;
    padding: 27px 37px;
    width: 100%;
    border-radius: 12px;
    background: #FFF;
    display: flex;
    .block{
        max-width: 368px;
        width: 100%;
        padding-right: 37px;
        margin-right: 37px;
        border-right: 1px solid #E9EBEF;
    }
    .block:last-child{
        border-right: none;
        padding-right:0;
        margin-right: 0;
    }
    .fieldGroup {
        margin-bottom: 20px;
        display: flex;
        flex-direction: column;
        > label {
            margin-bottom: 16px;
            color: #000;
            font-size: 20px;
            font-style: normal;
            font-weight: 600;
            line-height: normal;
        }
    }
    .checkboxRow{
        display: flex;
        align-items: center;
        gap: 48px;
    }
    .checkboxPart{
        label{
            color: #000;
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
            display: flex;
            align-items: center;
        }
        input{
            width: 20px;
            height: 20px;
            margin-right: 8px;
        }
    }
    select{
        border-radius: 3px;
        border: 1px solid #B8B8B8;
        background: #FAFAFA;
        outline:none;
        padding: 10px 16px;
        
    }
    .team-table {
        width: 100%;
        border-collapse: collapse;
        font-size: 14px;
    }
    .team-loading {
        color: #6b7280;
        font-size: 14px;
        padding: 8px 0;
    }
    .team-table th,
    .team-table td {
        text-align: left;
        padding: 8px 6px;
        border-bottom: none;
    }
    .team-table tr {
        border-bottom: 1px solid #e4e4e4;
    }
    .team-table th {
        font-size: 12px;
        letter-spacing: 0.4px;
        color: #000;
    }
    .team-row {
        cursor: pointer;
    }
    .team-row:hover {
        background: #f7f9fc;
    }
    .team-row.selected {
        background: #eef3ff;
    }
    .team-cell {
        display: flex;
        align-items: center;
        gap: 10px;
    }
    .team-logo {
        width: 24px;
        height: 24px;
        border-radius: 50%;
        object-fit: cover;
    }
    .team-row.selected .slot {
        color: rgb(108, 109, 111);
    }
    .slot {
        color: #1a5fff;
        font-weight: 500;
        text-align: right;
    }
    .subtitle{
        color: #000;
        font-size: 24px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        margin-bottom: 24px;
    }
    p{
        color: #000;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }
    b{
        font-weight: 600; 
    }
    .buttonsContainer{
        display: flex;
        flex-direction: column;
        gap: 12px;
        margin-top: 32px;
        button{
            border-radius: 4px;
            background: #1C4F9E;
            padding: 12px 24px;
            color: #FFF;
            font-size: 20px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
            cursor: pointer;
            &:disabled {
                background: #bfbfbf;    
                color: #f0f0f0;           
                cursor: not-allowed;     
                opacity: 0.7;            
            }
        }
    }
    .checkboxField{
        display:flex;
        align-items: center;
        gap: 16px;
        margin-bottom: 16px;
        span{
            color: #000;
            font-size: 20px;
            font-style: normal;
            font-weight: 600;
            line-height: normal;
        }
        input{
            width:20px;
            height:20px
        }
    }
`;


export const InputContainer = styled.div`
  max-width: 367px;
  width: 100%;
  position: relative;
  font-family: "Saira Semi Condensed", sans-serif;
  margin-bottom: 20px;
  label {
    display: block;
    color: #000;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin-bottom: 16px;
  }
`;

export const InputWrap = styled.input`
  outline: ${(props) => (props.error ? "1px solid red" : "1px solid #AFB4B9")};
  width: 100%;
  height: 46px;
  color: #0e1118;
  background-color: transparent;
    border-radius: 3px;
    border: 1px solid #B8B8B8;
     padding: 10px 9px 11px 16px;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  ::placeholder {
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
  }
  input:invalid + span::after {
    content: "✖";
    max-width: 200px;
    padding-left: 5px;
  }

  input:valid + span::after {
    content: "✓";
    max-width: 200px;
    padding-left: 5px;
  }
`;

